export enum ToastStatus {
  SUCCESS = "success",
  ERROR = "error",
}
